/* American Threads Co - Judge.me review trimming.
   Clamps each review body to two lines with a Read more toggle, and
   keeps only the first two reviews visible behind a Show more button.
   Judge.me renders asynchronously, so a MutationObserver re-runs this. */
(function () {
  var queued = false;

  function setup() {
    queued = false;

    var wraps = document.querySelectorAll('.jm-review-body-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.getAttribute('data-atc-rev')) continue;
      var body = w.querySelector('.jm-review-content__body');
      if (!body) continue;
      w.setAttribute('data-atc-rev', '1');

      /* A clamped -webkit-box does not overflow, so compare the clamped
         height with the height it would have fully expanded. */
      var clamped = body.getBoundingClientRect().height;
      w.classList.add('atc-rev-open');
      var full = body.getBoundingClientRect().height;
      w.classList.remove('atc-rev-open');
      if (full - clamped < 4) continue;

      (function (w) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'atc-rev-toggle';
        b.textContent = 'Read more';
        b.addEventListener('click', function () {
          b.textContent = w.classList.toggle('atc-rev-open') ? 'Read less' : 'Read more';
        });
        w.appendChild(b);
      })(w);
    }

    var list = document.querySelector('.jdgm-review-list');
    if (list && !list.getAttribute('data-atc-more')) {
      var items = list.querySelectorAll('.jm-review-item');
      if (items.length > 2) {
        list.setAttribute('data-atc-more', '1');
        (function (list) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'atc-rev-more';
          btn.textContent = 'Show more reviews';
          btn.addEventListener('click', function () {
            btn.textContent = list.classList.toggle('atc-rev-all') ? 'Show fewer reviews' : 'Show more reviews';
          });
          list.appendChild(btn);
        })(list);
      }
    }
  }

  function schedule() {
    if (!queued) { queued = true; setTimeout(setup, 50); }
  }

  document.addEventListener('DOMContentLoaded', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
